<template>
  <div>
  
    <section class="subpage-head">
      <div class="container">
        <h1>Subscribe now!</h1>
      </div>
    </section>
    
    
    <section class="login-reg">
      <div class="container">
        <div class="log-box main">
          <form class="gen-form" v-on:submit.prevent="selectPkg">
            <h2>Access replays of live events</h2>
            <p></p>
            <div class="form-act">
              <button class="lbtn">Subscribe now</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  
  
  </div>
</template>

<script>
import api from './api';
import mainNav from './mainNav';
export default {
  mixins: [mainNav],
  data: ()=>({
    menuOpen: false,
    menuSubOpen: null,
    currentUser: appRoot.loggedIn,
    packages: [],
  }),
  mounted() {
    this.loadPackages();
  },
  methods: {
    async loadPackages() {
      var items=(await api.list("Package", {})).items;
      this.packages=items;
    },
    selectPkg(pkg) {
      this.$router.push("/user/register");
    },
  }
}
</script>
